import { useParams } from 'react-router-dom';
import { ImqBrokerHealthQuestionnaireDomainParams } from 'store/pages/quote/imq-add-employees/health-questionnaire-entry/pageStore';

export const useImqBrokerHealthQuestionnaireParams = (): ImqBrokerHealthQuestionnaireDomainParams => {
  const { groupId, periodId, cartId, subscriberId, entityId } = useParams<{
    groupId: string;
    periodId: string;
    cartId: string;
    subscriberId: string;
    entityId: string;
  }>();

  if (!groupId || !periodId || !cartId || !subscriberId || !entityId) {
    throw new Error(
      `useImqBrokerHealthQuestionnaireParams: missing URL params. groupId=${groupId}, periodId=${periodId}, cartId=${cartId}, subscriberId=${subscriberId}, entityId=${entityId}`,
    );
  }

  return { groupId, periodId, cartId, subscriberId, entityId };
};
